import * as services from '../services'
import * as TYPES from './mutations-types'
import state from './state'

export const addCompanyDomain = ({ dispatch }, payload) =>
    services.addNewDomain(payload)
    .then(({message, status_code}) => {
      console.log(message, status_code);
    })


/**
 * Retrieves all domains list for current company
 */
export const LOAD_DOMAIN_LIST = ({ dispatch }) => {

	services.getDomains().then( (response) => {
		console.log('state', state)

		dispatch('setDomains', response.data )
		return Promise.resolve(response)
	})
	.catch((error) => {

		console.log('error', error)
		return Promise.reject('FAIL_IN_LOAD_COMPANY_DOMAINS') // keep promise chain
	})
}

export const setDomains = ({ commit }, list) => {
  console.log('commiter', commit)
  console.log('list', list)
  // Commit the mutations
  commit(TYPES.SET_DOMAIN_LIST, list)

  console.log(state)

	return Promise.resolve(list) // keep promise chain
}




// WEBPACK FOOTER //
// ./src/app/company/vuex/actions.js